import React from 'react';
import { Box } from '@material-ui/core';
import { object } from 'prop-types';
import { useTheme } from '@material-ui/styles';

const NotificationEmpty = ({
  snsList: { list },
}) => {
  const theme = useTheme();
  const emptyIcon = (
    <svg width="112" height="112" viewBox="0 0 112 112" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd" d="M56 112C86.9279 112 112 86.9279 112 56C112 25.0721 86.9279 0 56 0C25.0721 0 0 25.0721 0 56C0 86.9279 25.0721 112 56 112Z" fill={theme.palette.colors.corePink} fillOpacity="0.08" />
      <path fillRule="evenodd" clipRule="evenodd" d="M80 22H88V23.875L84 29.5H88V32H80V30.125L84 24.5H80V22ZM70 36H76V37.5L73 42H76V44H70V42.5L73 38H70V36ZM57.9865 37.7668C57.871 36.7721 57.0257 36 56 36C54.8954 36 54 36.8954 54 38V40.1418C47.2154 41.1122 42 46.9471 42 54V62C42 64.8954 40.8954 66 38 66V70H50L50.0102 70.3525C50.1927 73.5022 52.8046 76 56 76C59.3137 76 62 73.3137 62 70H74V66C71.1046 66 70 64.8954 70 62V54C70 46.9471 64.7846 41.1122 58 40.1418V38L57.9865 37.7668ZM56 72C54.8954 72 54 71.1046 54 70H58L57.9865 70.2332C57.871 71.2279 57.0257 72 56 72ZM56 44C50.4772 44 46 48.4772 46 54V62C46 63.3922 45.7846 64.62 45.3678 65.6696L45.226 66H66.772L66.6322 65.6696C66.2617 64.7366 66.0503 63.6628 66.008 62.4579L66 62V54C66 48.4772 61.5228 44 56 44Z" fill={theme.palette.colors.corePink} />
    </svg>
  );
  return (
    <Box style={{
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100%',
    }}
    >
      {emptyIcon}
      <Box style={{
        marginTop: 12,
        fontFamily: 'Montserrat',
        fontSize: 14,
        lineHeight: '20px',
        color: '#546264',
      }}
      >
        {list && list.noNotifications}
      </Box>
    </Box>
  );
};

NotificationEmpty.propTypes = {
  snsList: object,
};

export default NotificationEmpty;
